import * as dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryResultsStudyStatisticsForAgenda } from 'gql/queries/results';

import Agenda from './Agenda';

const AgendaContainer = ({
  course,
  isSingle,
  refetchAgendaOccurrences,
  ...props
}) => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState();
  const sunday = dayjs(new Date()).isoWeekday(7).$d;
  const [currentSunday, setCurrentSunday] = useState(sunday);
  const isLookingCurrentWeek =
    dayjs(sunday).format('L') === dayjs(currentSunday).format('L');
  const {
    getResultsStudyStatisticsForAgenda,
    isLoading: isLoadingAgenda,
    data: dataAgenda,
  } = useQueryResultsStudyStatisticsForAgenda();
  const refreshAgenda = useCallback(() => {
    getResultsStudyStatisticsForAgenda({
      variables: {
        courseId: isSingle ? course?.id : null,
        sunday: currentSunday,
      },
    });
  }, [course, currentSunday, getResultsStudyStatisticsForAgenda, isSingle]);
  useEffect(() => {
    refreshAgenda();
  }, [currentSunday, refetchAgendaOccurrences, refreshAgenda]);
  const agenda = isLoadingAgenda
    ? null
    : dataAgenda.resultsStudyStatisticsForAgenda;
  const handleWeekPrevious = useCallback(() => {
    setCurrentSunday(dayjs(currentSunday).subtract(7, 'day').$d);
  }, [currentSunday]);
  const handleWeekNext = useCallback(() => {
    setCurrentSunday(dayjs(currentSunday).add(7, 'day').$d);
  }, [currentSunday]);
  const handleWeekCurrent = useCallback(() => {
    setCurrentSunday(sunday);
  }, [sunday]);
  useEffect(() => {
    const dayToSelect = agenda?.statistics.find(
      (day) =>
        dayjs(new Date()).format('L').toString() ===
        dayjs(day.date).format('L').toString(),
    );
    const firstDay = agenda?.statistics[0];
    setSelectedDay(dayToSelect || firstDay);
  }, [agenda]);
  return (
    <Agenda
      agenda={agenda}
      handleDaySelect={setSelectedDay}
      handleWeekCurrent={handleWeekCurrent}
      handleWeekNext={handleWeekNext}
      handleWeekPrevious={handleWeekPrevious}
      isLookingCurrentWeek={isLookingCurrentWeek}
      isSingle={isSingle}
      refreshAgenda={refreshAgenda}
      selectedDay={selectedDay}
      t={t}
      {...props}
    />
  );
};

AgendaContainer.propTypes = {
  course: PropTypes.object,
  isSingle: PropTypes.bool,
  refetchAgendaOccurrences: PropTypes.number,
};

AgendaContainer.defaultProps = {
  course: undefined,
  isSingle: undefined,
  refetchAgendaOccurrences: undefined,
};
export default AgendaContainer;
